import {
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";

export default WebhookTable;

function WebhookTable(props) {
  const { webhooks, onEditWebhook, onRemoveWebhook } = props;

  if (webhooks.length === 0) return null;

  return (
    <Table>
      <TableHead>
        <TableHeader>Webhook Url</TableHeader>
        <TableHeader>Action</TableHeader>
      </TableHead>
      <TableBody>
        {webhooks.map((webhook, idx) => {
          const handleEditWebhook = (e) => {
            e.stopPropagation();
            onEditWebhook(webhook, idx);
          };
          const handleRemoveWebhook = (e) => {
            e.stopPropagation();
            onRemoveWebhook(idx);
          };

          return (
            <TableRow key={idx}>
              <TableCell>
                <p>{webhook.endpointUrl}</p>
              </TableCell>
              <TableCell>
                <div className="flex items-center gap-x-2">
                  <Button
                    plain
                    onClick={handleEditWebhook}
                  >
                    <PencilIcon />
                  </Button>
                  <Button
                    plain
                    onClick={handleRemoveWebhook}
                  >
                    <TrashIcon />
                  </Button>
                </div>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
